// extracted by mini-css-extract-plugin
export default {"label":"FormCheckbox_label__AtFEZ","checked":"FormCheckbox_checked__Vixyw"};